//Trump properties
var allProperties = ["2014", "2015", "2016", "2017"];

//Parses date for correct time format
var parseDate = d3.time.format("%b").parse;

//Loads the data
d3.csv("data/weapons.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.weapons = +d.weapons;
    d.date = parseDate(d.date);
  });

  //Organizes the data
  //data.sort(function(a,b) { return a.year - b.year; });
  var maxY = d3.max(data, function(d) { return d.weapons; });
  var maxX = d3.max(data, function(d) { return d.date; });
  var minX = d3.min(data, function(d) { return d.date; });

  //Map the property names to the data
  allProperties = d3.set(data.map(function(d) { return d.year; })).values();

  //Make a chart for each property
  var charts = allProperties.map(makeChart);

  d3.select(window).on("resize", function () {
    charts.forEach(function(chart) {
      chart.resize();
    })
  });

  function makeChart(name, chartIndex) {

    //Append individual chart div
    var chartContainer = d3.select(".gia-chart").append("div")
      .attr("class", "g-chart-container");

    //Margin conventions
    var margin = {top: 5, right: 5, bottom: 15, left: 11};

    var widther = d3.select(".g-chart-container").node().clientWidth;

    var width = (widther) - margin.left - margin.right,
      height = 250 - margin.top - margin.bottom;

    //Creates the xScale
    var xScale = d3.time.scale()
      .range([0, width]);

    //Creates the yScale
    var yScale = d3.scale.linear()
      .range([height, 0]);

    //line function convention (feeds an array)
    var line = d3.svg.line()
      .defined(function(d) { return d.weapons != 0; })
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.weapons); });

    //area function
    var area = d3.svg.area()
      .defined(function(d) { return d.weapons != 0; })
      .x(function(d) {return xScale(d.date); })
      .y0(height)
      .y1(function(d) {return yScale(d.weapons); });

    //Defines the xScale max
    xScale.domain([minX, maxX]);

    //Defines the yScale max
    yScale.domain([0, maxY]);

    //Defines the y axis styles
    var yAxis = d3.svg.axis()
      .scale(yScale)
      .tickSize(-width)
      .tickPadding(4)
      .ticks(5)
      .tickFormat(function(d) { return d/1000; })
      .orient("left");

    //Defines the y axis styles
    var xAxis = d3.svg.axis()
      .scale(xScale)
      .tickPadding(0)
      .orient("bottom")
      .tickValues([minX, maxX])
      .tickFormat(d3.time.format("%b"));

    //Finds the data associated with each property name
    var myLocationName = name;

    var myLocationData = data.filter(function(d) {
      return d.year === myLocationName;
    });

    //Sets value for ending dot on line
    var maxXdot = d3.max(myLocationData, function(d) { return d.date; });

    var cityName = d3.max(myLocationData, function(d) { return d.state; });

    //Appends chart heading div
    var chartHeading = chartContainer.append("div")
      .attr("class", "g-heading");  

    //Appends the property name to the individual chart container
    var chartLocation = chartHeading.append("h5")
      .attr("class", "g-property");  

    //Appends the property name to the individual chart container
    var chartCity = chartHeading.append("p")
      .attr("class", "g-city");   

    //Appends the property chart to the individual chart container
    var chart = chartContainer.append("div")
      .attr("class", "g-chart");

    //Assigns the property name
    chartLocation.text(myLocationName);
    chartCity.text(cityName);

    //Appends the svg to the chart-container div
    var svg = chart.append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    //Appends the y axis
    var yAxisGroup = svg.append("g")
      .attr("class", "y axis")
      .call(yAxis)
      .selectAll("g")
      .classed("g-baseline", function(d) {return d == 0});

    //Appends the x axis
    var xAxisGroup = svg.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .selectAll("g")
      .classed("g-start", function(d) {return d == minX})
      .classed("g-end", function(d) {return d == maxX});

    //Binds the data to the area
    var drawarea = svg.append("path")
      .datum(myLocationData)
      .attr("class", "area")
      .attr("d", area);

    //Binds the data to the line
    var drawline = svg.append("path")
      .datum(myLocationData)
      .attr("class", "line")
      .attr("d", line)
      .selectAll("line"); 

    return {
      resize: function () {
        //new margin
        var newMargin = {top: 5, right: 5, bottom: 15, left: 11};

        var newWidther = d3.select(".g-chart-container").node().clientWidth;

        var newWidth = (newWidther) - newMargin.left - newMargin.right;

        //Change the width of the svg
        d3.selectAll("svg")
          .attr("width", newWidth + newMargin.left + newMargin.right);

        //Change the xScale
        xScale
          .range([0, newWidth]);

        //Update the lines
        line = d3.svg.line()
          .defined(function(d) { return d.weapons != 0; })
          .x(function(d) { return xScale(d.date); })
          .y(function(d) { return yScale(d.weapons); });

        d3.selectAll('.line')
          .attr("d", line); 

        //Update the area
        area = d3.svg.area()
          .defined(function(d) { return d.weapons != 0; })
          .x(function(d) {return xScale(d.date); })
          .y0(height)
          .y1(function(d) {return yScale(d.weapons); });

        d3.selectAll('.area')
          .attr("d", area);

        //Updates xAxis
        d3.selectAll(".x.axis")
          .call(xAxis);

        xAxis
          .scale(xScale);

        //Updates yAxis
        d3.selectAll(".y.axis")
          .call(yAxis);

        yAxis
          .tickSize(-newWidth);
      }
    };
  }
}